module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-excel-502300a3.svg";